module.exports = __webpack_public_path__ + "img/69.bd22bccd.jpg";